import ApiService from '@/common/api.service'

export default {
  getRelationship () {
    return new Promise((resolve, reject) => {
      ApiService.query('/relationship').then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getEventMaster () {
    return new Promise((resolve, reject) => {
      ApiService.query('/event-master').then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  createOrUpdateChronicle (memberFamilies) {
    return new Promise((resolve, reject) => {
      ApiService.post('my-chronicle/createOrUpdate', memberFamilies).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  createOrUpdateChronicleByMemberId (memberFamilies, memberId) {
    return new Promise((resolve, reject) => {
      ApiService.post(`my-chronicle/createOrUpdate/${memberId}`, memberFamilies).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
